import { FormHelperText } from "@mui/material";
import React from "react";
import {
  ERROR_HELPERTEXT_STYLES,
  PRIMARY_COLOR,
  WARNING_COLOR,
} from "../utils";
import { ConfigProvider, Input } from "antd";

const TextArea = ({
  label,
  value,
  disabled,
  type,
  name,
  error_state,
  error_text,
  placeholder,
  helperText,
  handleChange,
  required = false,
}) => {
  return (
    <div
      className={`textfield ${error_state && "error_textfield"}`}
      style={{
        alignItems: helperText && "flex-start",
      }}
    >
      <label
        htmlFor={name}
        style={{ marginBottom: (helperText || error_state) && "10px" }}
      >
        {label}
        {required ? <span>*</span> : ""}
      </label>
      <div>
        <ConfigProvider
          theme={{
            components: {
              Input: {
                activeBorderColor: PRIMARY_COLOR,
                hoverBorderColor: PRIMARY_COLOR,
                activeShadow: "none",
                errorActiveShadow: "none",
              },
            },
            token: {
              colorErrorOutline: "none",
              colorError: WARNING_COLOR,
              colorErrorBorderHover: "none",
            },
          }}
        >
          <Input.TextArea
            type={type ? type : "text"}
            id={name}
            name={name}
            size="large"
            className="input"
            readOnly={disabled}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            status={error_state && "error"}
          />
        </ConfigProvider>
        {helperText ? (
          <FormHelperText
            sx={{
              fontStyle: "italic",
              fontSize: "0.75rem",
              color: "#a0aec0",
              margin: "8px 0",
              lineHeight: "1rem",
              letterSpacing: "0.7px",
              fontFamily: "Montserrat",
            }}
          >
            {helperText}
          </FormHelperText>
        ) : (
          ""
        )}
        {error_state && (
          <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
            {error_text}
          </FormHelperText>
        )}
      </div>
    </div>
  );
};

export default TextArea;
